'use strict';

/*
 * Verzögert die Anzeige des Inhalts, um das "Flackern" weg zu bekommen
 */

class DelayDisplay {

    // instantiate object
    constructor() {
        this.sidebarContainer = document.querySelector(".sidebar-container");
        this.contentContainer = document.querySelector(".content-container");

        // if no event listener required, return immediately
        if ( this.sidebarContainer == null && this.contentContainer == null ) 
            return;
        
        this.events();
    }

    // event listeners
    events() {
        //window.addEventListener("load", () => this.displayWikiData());
        document.addEventListener("DOMContentLoaded", () => this.displayWikiData());
    }

    // methods
    displayWikiData() {

        setTimeout(() => {
            if(this.sidebarContainer)
                this.sidebarContainer.classList.remove("sidebar-container--invisible");

            if(this.contentContainer)
            this.contentContainer.classList.remove("content-container--invisible");
        }, 100);

    }
}

export default DelayDisplay;